import api from "../axios/axiosConfig";

export const getBalance = async (wallet_type: number = 0) => {
    
    try {
        const response = await api.get(`/wallet/Balance?wallet_type=${wallet_type}`);
        return response.data;
    } catch (error: any) {
        throw error;
    }
};

export const getAllChargeTags = async ()  => {
    try {
        const response = await api.get(`/ChargeTags`);
        return response.data;
    } catch (error: any) {
        throw error;
    }
};

export const geChargeTagsById = async (tagId : string)  => {
    try {
        const response = await api.get(`/ChargeTags/${tagId}`);
        return response.data;
    } catch (error: any) {
        throw error;
    }
};

export const addChargeTag = async (tagName: string, tagId: string, userId: string) => {
    try {
        const response = await api.post(`/ChargeTags`,
        {
            tagId,
            tagName,
            userId,
        });
        return response.data;
    } catch (error: any) {
        throw error;
    }
};

export const updateChargeTag = async (tagName: string, tagId: string, userId: string) => {
    try {
        const response = await api.put(`/ChargeTags/${tagId}`,
        {
            tagId,
            tagName,
            userId,
        });
        return response;
    } catch (error: any) {
        throw error;
    }
};

export const deleteChargeTag = async (tagId: string) => {
    try {
        const response = await api.delete(`/ChargeTags/${tagId}`);
        return response;
    } catch (error: any) {
        throw error;
    }
};
